<div class="frontpage-widget cover-image-trees-gray">
  <div class="whitebox dark-blue">
    <div class="container">
      <p class="text-muted">SCREENING <i class="fa fa-chevron-right"></i></p>
      <h2>Søg lokalitet</h2>
      <p>Start med at finde den lokalitet, du ønsker at se screeningsresultatet for</p>
    </div>
  </div>
</div>

<div class="container">
  <div class="row mt-5">

    <div class="col-sm-12 col-lg-12">
      <h4 class="search-call-to-attention vd-fade fast" [ngClass]="{'out': !initialSearch, 'in': initialSearch}">Start
        din søgning</h4>
      <div>
        <div class="vd-main-search-bar no-searchresults" [ngClass]="{'no-searchresults': initialSearch}">
          <input type="text" id="searchInput" [(ngModel)]="searchText" (keyup)="onSearch()"
            [disabled]="isSearching"
            aria-describedby="searchinput" placeholder="Søg efter lokalitetsnavn eller nummer (f.eks. 671-00281)...">
          <div>
            <span [ngClass]="{'in': isSearching, 'out': !isSearching}" class="vd-fade" style="margin-top: 2px"><i class="fa fa-circle-o-notch fa-spin fa-lg mr-3"></i></span>
            <button class="btn btn-secondary" [disabled]="isSearching" (click)="onSearch()">SØG <i class="fa fa-search"></i></button>
          </div>
        </div>

      </div>
    </div>

    <div class="col-sm-12 col-lg-12">
      <div class="btn-group mt-3">
        <!-- <div class=""><span class="text-muted">Filtre:</span></div> -->
        <div class="dropdown">
          <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{locationTypeFilter?locationTypeFilter.text:'Vælg kategori'}}
          </a>

          <div class="dropdown-menu">
            <a *ngFor="let filter of locationTypeFilters" class="dropdown-item" (click)="locationTypeFilter=filter;refreshSearch();">
              {{filter.text}}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="locationTypeFilter=null;refreshSearch();">Vis alle</a>
          </div>
        </div>

        <div class="dropdown ml-3">
          <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{statusFilter?statusFilter.text:"Vælg vurdering"}}
          </a>

          <div class="dropdown-menu">
            <a *ngFor="let filter of statusFilters" class="dropdown-item" (click)="statusFilter=filter;checkFilterStatus();refreshSearch();">
              <span class="risk-indicator-screening"
                [ngClass]="{
                  'no-risk':(filter.status==screeningPolygonStatus.NoRisk),
                  'risk':(filter.status==screeningPolygonStatus.Risk && filter.calculationType == highestRiskCalculationType.None),
                  'risk-v1':(filter.status==screeningPolygonStatus.Risk && filter.calculationType == highestRiskCalculationType.Screening)}">
                <span class="icon"></span>
              </span>
              {{filter.text}}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="statusFilter=null;refreshSearch();">Vis alle</a>
          </div>
        </div>

        <div class="form-control text-input sub-input ml-3">
          <input [(ngModel)]="contaminantName" (ngModelChange)="filterContaminants($event);"
            [matAutocomplete]="contaminantAutoComplete" name="contaminant" type="text" class="text-input"
            placeholder="Vælg forureningsstof" required />
          <mat-autocomplete #contaminantAutoComplete="matAutocomplete" (optionSelected)="refreshSearch()" panelWidth="auto"
            autoActiveFirstOption>
            <mat-option *ngFor="let compound of filteredCompoundList" [value]="compound.name">
              {{ compound.name }}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="form-control text-input sub-input ml-3">
          <span class="mr-1">Faktor fra:</span>
          <input type="number" [(ngModel)]="minScreeningFactor" (focusout)="refreshSearch();">
        </div>

        <div class="form-control text-input sub-input ml-1">
          <span class="mr-1">Faktor til:</span>
          <input type="number" [(ngModel)]="maxScreeningFactor" (focusout)="refreshSearch();">
        </div>
      </div>
    </div>
  </div>

  <!--<div [ngClass]="{'in': isSearching, 'out': !isSearching}" class="col-sm-12 col-lg-12 text-center mt-5 vd-fade position-absolute"
    style="position: absolute;left: 0;">
    <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
    <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Søger efter lokaliteter...</h3>
    <p class="text-muted mt-1">Vent et øjeblik</p>

  </div>-->
  <div *ngIf="!isSearching && searchResults != null && (searchResults?.length < 1)"
    class="col-sm-12 col-lg-12 mb-5 mt-5 text-center">
    <img style="width:8rem" src="assets/undraw_no_data_qbuo.svg">
    <p class="text-muted mt-3" i18n>Der blev desværre ikke fundet nogen lokaliteter...</p>
  </div>

  <div class="row mt-5 mb-5 vd-fade " [ngClass]="{'in': displaySearchResults, 'out': !displaySearchResults}">
    <div class="col-sm-12 col-lg-12">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th (click)="setOrderBy(locationSearchOrder.LocationNumber)">Lokalitetsnr.</th>
            <th (click)="setOrderBy(locationSearchOrder.LocationName)">Navn</th>
            <th (click)="setOrderBy(locationSearchOrder.ScreeningLocationType)">Kategori</th>
            <th (click)="setOrderBy(locationSearchOrder.ScreeningFactor)">Faktor <span
                class="text-muted">(alvorligste)</span></th>
            <th (click)="setOrderBy(locationSearchOrder.ScreeningPollutant)">Forureningsstof</th>
            <th (click)="setOrderBy(locationSearchOrder.ScreeningConcentration)">Koncentration</th>
            <th (click)="setOrderBy(locationSearchOrder.ScreeningStatus)">Vurdering</th>
            <th (click)="setOrderBy(locationSearchOrder.ScreeningAt)">Dato</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let location of searchResults" [routerLink]="['/screening/location-details', location.id]">
            <td>{{location.number}}</td>
            <td>{{location.name}}</td>
            <td>{{getLocationTypeString(location.screeningLocationType)}}</td>
            <td>
              <span [ngSwitch]="location.polygonStatus">
                <span *ngSwitchCase="riskAssessmentStatus.Risk" class="text-danger"
                  style="font-weight:900">{{location.screeningFactor | numberOrDefault | number:'1.0-1'}}</span>
                <span *ngSwitchCase="riskAssessmentStatus.NoRisk" class="text-success"
                  style="font-weight:700">{{location.screeningFactor | numberOrDefault | number:'1.0-1'}}</span>
              </span>
            </td>
            <td>{{location.screeningPollutant}}</td>
            <td>{{getNumberWithSignificantDigits(location.screeningConcentration)}} μg/L</td>
            <td>
              <div class="risk-indicator-screening"
                [ngClass]="{
                                'no-risk': location.polygonStatus == riskAssessmentStatus.NoRisk,
                                'risk': location.polygonStatus == riskAssessmentStatus.Risk,
                                'risk-v1': (location.polygonStatus == riskAssessmentStatus.Risk) && location.screeningLocationType == screeningLocationType.V1}">
              </div>
              <span [ngSwitch]="location.polygonStatus" class="ml-1">
                <span *ngSwitchCase="riskAssessmentStatus.Risk"><b>Risiko</b></span>
                <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
              </span>
              <span *ngIf="location.screeningLocationType == screeningLocationType.V1" class="text-muted"> (V1)</span>
            </td>
            <td>{{location.screeningAt | date:'d/M-yyyy'}}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center" *ngIf="!isContinuing && hasMoreSearchResults">
        <a href="javascript:void(0)" (click)="getMoreResults()">Hent flere resultater</a>
      </div>
      <div class="text-center" *ngIf="isContinuing">
        <p class="text-muted"><i class="fa fa-spinner fa-spin"></i> Henter lokaliteter</p>
      </div>
    </div>
  </div>
</div>